import axios, { AxiosInstance } from "axios";
import { BASE_URL } from 'constants/api';
import { AdminRole, Auth2FAResponse, AuthResponse, GetUserResponse } from "types/auth";
import { getAccessToken } from "utils/auth";

export class AuthAPI {
  private _api: AxiosInstance;
  constructor() {
    this._api = axios.create({
      baseURL: BASE_URL,
      headers: { "Content-Type": "application/json" },
      withCredentials: true,
    });

    this._api.defaults.headers.put["Content-Type"] = "application/json";
  }

  async auth(email: string, password: string): Promise<AuthResponse> {
    const url = "/api/auth/login";
    const {data} = await this._api.post<AuthResponse>(url, {
      email: email.toLowerCase(),
      password,
    });

		const token = data?.authInfo?.tokens?.access

		if (token) {
			localStorage.setItem("accessToken", token);
		}

		return data
  }

  async getUser(): Promise<GetUserResponse> {
    const url = "/api/admins/me";
    const {data} = await this._api.get<GetUserResponse>(url, {
			headers:{ authorization: getAccessToken()}
		});

		return data
  }
  async authWith2FA(email: string, password: string, code: string): Promise<Auth2FAResponse> {
    const url = "/api/auth/login-with-2fa";
    const {data} = await this._api.post<Auth2FAResponse>(url, {
      email: email.toLowerCase(),
      password,
			code
    });

		const token = data.tokens.access

		if (token) {
			localStorage.setItem("accessToken", token);
		}

		return data
  }
  async getQRCore(): Promise<{qrCodeUrl: "string"}> {
    const url = "/api/admins/2fa/generate";
    const {data} = await this._api.post<{qrCodeUrl: "string"}>(url, {}, {
			headers:{ authorization: getAccessToken()}
		});

		return data
  }

  async verify2FASetup(code: string) {
    const url = "/api/admins/2fa/verify";
    await this._api.post(url, {
      code,
    }, {
			headers:{ authorization: getAccessToken()}
		});
  }

  async refresh() {
    const url = "/api/auth/refresh";
    const { data } = await this._api.post<{ access: string, role: AdminRole }>(url, {}, {
			headers:{ authorization: getAccessToken()}
		});

    localStorage.setItem("accessToken", data.access);

		const user = await this.getUser()

		return user
  }

  async logout() {
    const url = "/api/auth/logout";
    await this._api.post(url);

    localStorage.removeItem("accessToken");
    sessionStorage.removeItem("accessToken");
  }
}

export const authAPI = new AuthAPI();
